
if ($(window).width() <= 800 && $('.mobile_bg .m-mixed-layout__inner').length > 0) {
$('.mobile_bg .m-mixed-layout__inner').slick({
  centerMode: true,
  centerPadding: '40px',
  slidesToShow: 1,
  draggable: true,
  dots: true,
  arrows: false
 
});
}

// new unit radio design 


$('.toggle_radio_tabs').on('click',function(e) {
  e.preventDefault();

  let $this = $(this);
  var isRadioDesign = $('body').hasClass('unit-radio-design');
  var alreadyActive = $this.parent().hasClass('tab-active');

  // Radio-style UX on unit-radio-design: clicking the already-active toggle does nothing
  // (the default accordion behaviour collapses the panel, which breaks a 2-option radio)
  if (isRadioDesign && alreadyActive) {
    return;
  }

  var tabId = $this.attr('data-tigger');
  $('.trigger_to_set').addClass('hidden');
  $('.sav_tab_2').addClass('hidden');
  $('.sav_tab_3').addClass('hidden');

  if(tabId){
    if(tabId == '#trigger_tab_1'){
      $('.m-add-to-cart-original').removeClass('hidden');
      if (isRadioDesign) {
        $('body').removeClass('pz-active-discovery').addClass('pz-active-single');
      }
    }else{
      $(`${tabId}`).removeClass('hidden');
      $('.m-add-to-cart-original').addClass('hidden');
      if(tabId == '#trigger_tab_2'){
        $('.sav_tab_2').removeClass('hidden');
      }
      if(tabId == '#trigger_tab_3'){
        $('.sav_tab_3').removeClass('hidden');
      }
      if (isRadioDesign) {
        $('body').removeClass('pz-active-single').addClass('pz-active-discovery');
      }
    }
  }

  $('.tab_item').removeClass('tab-active');

  var $target = $this.next();
  var $otherPanels = $this.parent().parent().find('li .inner_radio_set').not($target);

  if (alreadyActive) {
    // Accordion-style close (never fires on unit-radio-design due to early return above)
    $target.removeClass('show').slideUp(350);
    // $this.parent() already lost .tab-active from the reset above
  } else {
    // Close siblings, open this one — use explicit slideDown/slideUp so the
    // "is hidden?" check inside slideToggle can't misread a freshly-added .show class.
    $otherPanels.removeClass('show').slideUp(350);
    $target.addClass('show').slideDown(350);
    $this.parent().addClass('tab-active');
  }
});


$('#trigger_tab_2').on('click',function(e){
  e.preventDefault();
  $('#tab-2 form .btn_units .color_btn_ctm').trigger('click');
})
$('#trigger_tab_3').on('click',function(e){
  e.preventDefault();
  $('#tab-3 form .btn_units .color_btn_ctm').trigger('click');
})


// function changeStickyBtnText(){
//   var seleElemTab = $('.product_units_radio_wrp .tab-active .tab_horizon').attr('href');
//   console.log("yes im in mr.z",seleElemTab);
//     if(seleElemTab  == '#tab-2'){
//       $('.ctm_sticky_btn_wrp .stcky_btn').html("SELECT SHADES");
//     }else if(seleElemTab  == '#tab-3'){
//       $('.ctm_sticky_btn_wrp .stcky_btn').html("SELECT SHADES");
//     }else{
//       var tab1Btn = 'Add to bag';
//       $('.ctm_sticky_btn_wrp .stcky_btn').text(tab1Btn);
//     }
// }